import { canSyncAssets } from '../../service';
import type { OutlookSpace, ProjectId, TimeStreamProjects } from 'owa-timestream-types';
import newTimeStreamProject from './newTimeStreamProject';
import updateProject from './updateProject';

export default function insertProject(
    projects: TimeStreamProjects,
    projectId: ProjectId,
    outlookSpace: OutlookSpace,
    newlyCreated?: boolean,
    isPreview?: boolean
) {
    const project = newTimeStreamProject(projectId);
    updateProject(project, outlookSpace);

    project.newlyCreated = !!newlyCreated;
    project.isPreview = !!isPreview;
    project.canSync = canSyncAssets(projectId);

    return projects.set(projectId, project).get(projectId)!;
}
